import PgDialogSelectStock from './src/select-stock.vue'
import vue, { h, shallowReactive, getCurrentInstance } from 'vue'

const selectStockConstructor = vue.extend({
  setup(_, { expose }) {
    const props = shallowReactive({
      showClose: undefined,
      closeOnClickModal: undefined,
      closeOnPressEscape: undefined,
      appendToBody: undefined,
      visible: undefined,
      modal: undefined,
      title: undefined,
      width: undefined,
      data: undefined,
    })
    const { proxy } = getCurrentInstance()
    expose({
      show(options) {
        Object.keys(options).forEach((option) => (props[option] = options[option]))
      },
    })
    return () =>
      h(PgDialogSelectStock, {
        props,
        on: {
          'on-ok': (item) => {
            props.onOk(item)
          },
          'on-cancel': () => {
            props.onCancel()
          },
          closed: () => {
            proxy.$destroy(true)
            proxy.$el.parentNode?.removeChild(proxy.$el)
          },
        },
      })
  },
})

export function PgDialogSelectStockServer(options) {
  return new Promise((resolve, reject) => {
    const instance = new selectStockConstructor()
    options.onOk = (item) => {
      resolve(item)
    }
    options.onCancel = () => {
      reject()
    }
    instance.$mount()
    document.body.appendChild(instance.$el)
    instance.show(options)
  })
}

export { PgDialogSelectStock }
